import type { SVGProps } from 'react'

/**
 * THIS FILE IS AUTO GENERATED!
 * Direct changes to this file will be overwritten on next icons:build execution.
 * Changes have to be made in the assets/*.svg file.
 * Afterwards execute the icons:build command.
 */
export const Info = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 24 24"
    {...props}
  >
    <g
      transform="translate(5 5)"
      stroke="currentColor"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="square"
    >
      <circle cx={7} cy={7} r={7} strokeWidth={2} />
      <g transform="matrix(1 0 0 -1 6.25 10.5)">
        <path strokeWidth={2} d="M.75 0v4" />
        <circle
          cx={0.75}
          cy={6.45}
          r={1}
          fill="currentColor"
          strokeWidth={0.5}
        />
      </g>
    </g>
  </svg>
)
